const steps = [
  { icon: "ri-user-line", label: "People" },
  { icon: "ri-briefcase-line", label: "Work" },
  { icon: "ri-line-chart-line", label: "Performance" },
  { icon: "ri-settings-line", label: "Operations" },
  { icon: "ri-coins-line", label: "Revenue" },
  { icon: "ri-shield-check-line", label: "Management" },
];

export default function DataFlowSection() {
  return (
    <section className="relative py-16 md:py-24 bg-graphite-850 overflow-hidden">
      <div className="w-full px-4 sm:px-6 lg:px-8 xl:px-16">
        <div className="max-w-4xl mx-auto text-center mb-12 md:mb-16">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-white mb-4">
            One Record. <span className="text-emerald-accent">One Source of Truth.</span>
          </h2>
          <p className="text-silver-300 text-base md:text-lg max-w-2xl mx-auto">
            All StackMap products share a unified data model, eliminating duplication and improving accuracy across every department.
          </p>
        </div>

        <div className="hidden lg:flex items-center justify-center gap-3 max-w-6xl mx-auto">
          {steps.map((s, i) => (
            <div key={s.label} className="flex items-center gap-3">
              <div className="glass-card px-5 py-4 flex items-center gap-3 min-w-[140px] group">
                <div className="w-8 h-8 flex items-center justify-center rounded-md bg-graphite-800 group-hover:bg-emerald-accent/10 transition-colors duration-300">
                  <i className={`${s.icon} text-lg text-emerald-accent`} />
                </div>
                <span className="text-sm font-medium text-white whitespace-nowrap group-hover:text-emerald-soft transition-colors duration-300">{s.label}</span>
              </div>
              {i < steps.length - 1 && (
                <i className="ri-arrow-right-line text-lg text-graphite-700 flex-shrink-0" />
              )}
            </div>
          ))}
        </div>

        <div className="lg:hidden flex flex-col items-center gap-3 max-w-xs mx-auto">
          {steps.map((s, i) => (
            <div key={s.label} className="flex flex-col items-center gap-3 w-full">
              <div className="glass-card px-5 py-4 flex items-center gap-3 w-full group">
                <div className="w-8 h-8 flex items-center justify-center rounded-md bg-graphite-800 group-hover:bg-emerald-accent/10 transition-colors duration-300 flex-shrink-0">
                  <i className={`${s.icon} text-lg text-emerald-accent`} />
                </div>
                <span className="text-sm font-medium text-white group-hover:text-emerald-soft transition-colors duration-300">{s.label}</span>
              </div>
              {i < steps.length - 1 && (
                <i className="ri-arrow-down-line text-lg text-graphite-700" />
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
